import { loc } from './loc';

export default loc;
export { setLocale, onLocaleChanged } from './actions/setLocale';
export { format } from 'owa-string-utils';
export { formatToArray } from './utilities/formatToArray';
export { isStringNullOrWhiteSpace } from './utilities/isStringNullOrWhiteSpace';
export { initializeLocalization } from './actions/initializeLocalization';
export {
    getSupportedFallbackForLocale,
    SupportedLocale,
    localeManifest,
} from './utilities/getSupportedFallbackForLocale';
export { getLocalizedStringStore } from './store/store';
